import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function formatDate(dateString: string | null): string {
  if (!dateString) return 'No expiry'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function isExpired(dateString: string | null): boolean {
  if (!dateString) return false
  return new Date(dateString) < new Date()
}

export function daysUntilExpiry(dateString: string | null): number | null {
  if (!dateString) return null
  const diff = new Date(dateString).getTime() - new Date().getTime()
  return Math.ceil(diff / (1000 * 60 * 60 * 24))
}

export function maskCode(code: string): string {
  if (!code) return ''
  const show = Math.ceil(code.length * 0.6)
  return code.slice(0, show) + '*'.repeat(code.length - show)
}

export function formatUsageCount(count: number): string {
  if (count >= 1000) return `${(count / 1000).toFixed(1)}K`
  return count.toString()
}

export function formatDiscountBadge(raw: string | null | undefined): string {
  if (!raw) return ''
  const s = raw.trim()
  const leadMatch = s.match(/^(extra|flat|save|up to)/i)
  const lead = leadMatch ? leadMatch[1].toUpperCase() : ''
  // ₹ amount: "Rs 300", "Rs. 800", "₹500" — normalize to ₹N OFF
  const rsMatch = s.match(/(?:rs\.?|₹)\s*(\d+)/i)
  if (rsMatch) {
    return `${lead ? lead + ' ' : ''}₹${rsMatch[1]} OFF`.trim()
  }
  // percentage: normalize to N% OFF
  const pctMatch = s.match(/(\d+)\s*%/)
  if (pctMatch) {
    return `${lead ? lead + ' ' : ''}${pctMatch[1]}% OFF`.trim()
  }
  // fallback — couldn't parse a number, return as-is rather than blank it
  return s
}

export function extractPercentDiscount(discount: string | null | undefined): number {
  if (!discount) return 0
  // Only match a number immediately followed by a % sign — this
  // correctly skips flat-₹ discounts (e.g. "FLAT Rs 500 OFF"),
  // which must never be compared against percentage discounts.
  const m = discount.match(/(\d+)\s*%/)
  return m ? parseInt(m[1], 10) : 0
}

export const SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME || 'EndOverPay'
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://www.endoverpay.com'
